// extracted by mini-css-extract-plugin
export default {"container":"nE-z","dimension":"oE-z","dimensionLabels":"pE-z"};